import { useMeetingStore } from "../../stores/useMeetingStore";
import useShowError from "../utils/useShowError";
import useAxios from "./useAxios";

const useKickMeeting = () => {
    const meeting = useMeetingStore((state) => state.meeting);

    const { error, loading, setError, clearError, post } = useAxios();
    useShowError(error, clearError);

    const kickMeeting = async (name?: string, cb?: () => void) => {
        if (!meeting) return setError(`Missing meeting`);
        if (!name) return setError(`Missing participant`);

        await post(`/api/meeting/Kick?meetingId=${meeting.id}&userName=${name}`);

        cb && cb();
    };
    return {
        kickMeeting,
        loading,
    };
};

export default useKickMeeting;
